import React from 'react';

// SM1. Итог «Проверить» секции «Интеграций» (сейчас — «Журналы S3»): шаги по порядку, у каждого ✓ или ✗
// и пояснение сервера. Ответ бэкенда: { ok, steps: [{ name, ok, detail }], installations: [...] }.
const IntegrationCheckResult = ({ title, result, error }) => {
  if (!result && !error) return null;
  const steps = Array.isArray(result?.steps) ? result.steps : [];
  const ok = !error && Boolean(result?.ok);
  return (
    <div
      className={`sett-integration-check ${ok ? 'sett-integration-check--ok' : 'sett-integration-check--fail'}`}
      role="status"
      aria-label={`${title}: проверка — ${ok ? 'готово' : 'не прошла'}`}
    >
      {error ? (
        <div className="sett-integration-check__step">✗ Запрос проверки: {error}</div>
      ) : (
        steps.map((step, index) => (
          <div key={`${index}-${step.name}`} className="sett-integration-check__step">
            {step.ok ? '✓' : '✗'} {step.name}{step.detail ? ` — ${step.detail}` : ''}
          </div>
        ))
      )}
    </div>
  );
};

export default IntegrationCheckResult;
